import { Component } from 'react';

import { Button } from 'antd';

import { capitalize } from '../helpers/common';
import { formatDateDifference } from '../helpers/date';
import { sortDates, sortStrings } from '../helpers/filter';

import AppModal from '../components/AppModal';
import AppTable from '../components/AppTable';
import { COLUMN_SIZE } from '../components/AppTable/constants';

const commonColumnProperties = {
  ellipsis: true,
  sortDirections: ['ascend', 'descend']
};

class AnimalPopup extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const columns = [
      {
        align: 'center',
        dataIndex: 'id',
        fixed: 'left',
        noPadding: true,
        width: COLUMN_SIZE.XS,
        render: (value, record) => (
          <Button
            color="primary"
            size="small"
            variant="filled"
            key={value}
            onClick={() => this.props.onSelect(this.props.fieldKey, value, record)}>
            Select
          </Button>
        )
      },
      {
        ...commonColumnProperties,
        dataIndex: 'identifier',
        fixed: 'left',
        searchable: true,
        title: 'Livestock ID',
        width: COLUMN_SIZE.MD,
        sorter: (a, b) => sortStrings(a.identifier, b.identifier)
      },
      {
        ...commonColumnProperties,
        dataIndex: 'eartag_management_id',
        searchable: true,
        title: 'Mgmt Tag ID',
        width: COLUMN_SIZE.XL,
        sorter: (a, b) => sortStrings(a.eartag_management_id, b.eartag_management_id)
      },
      {
        ...commonColumnProperties,
        dataIndex: 'sex',
        title: 'Sex',
        width: COLUMN_SIZE.SM,
        render: value => capitalize(value)
      },
      {
        ...commonColumnProperties,
        dataIndex: 'colour',
        searchable: true,
        title: 'Colour',
        width: COLUMN_SIZE.SM,
        sorter: (a, b) => sortStrings(a.colour, b.colour)
      },
      {
        ...commonColumnProperties,
        dataIndex: 'dob_at',
        searchable: true,
        title: 'Age',
        width: COLUMN_SIZE.MD,
        onFilter: (value, record) => {
          const age = formatDateDifference(record.dob_at);

          return age.includes(value.toLowerCase());
        },
        render: (value, record) => formatDateDifference(record.dob_at),
        sorter: (a, b) => sortDates(a.dob_at, b.dob_at)
      },
      {
        ...commonColumnProperties,
        dataIndex: 'breeding_status',
        title: 'Breeding Status',
        width: COLUMN_SIZE.XL,
        sorter: (a, b) => sortStrings(a.breeding_status, b.breeding_status)
      }
    ];

    return (
      <AppModal isOpen confirmButtonHidden size="lg" title="Livestocks" handleCancel={() => this.props.onClose()}>
        <div className="py-4">
          <AppTable
            baseColumns={columns}
            dataSource={this.props.animals}
            loading={false}
            rowsSelectable={false}
            settings={false}
          />
        </div>
      </AppModal>
    );
  }
}

export default AnimalPopup;
